import React from 'react';
import { Button, Card, Typography } from 'antd';
import './Home.css';
import xinhe from '../assets/images/xinhe1.png';
import pengyue from '../assets/images/pengyue1.png';
import Invest2 from '../assets/images/Invest2.webp';
import Travel1 from '../assets/images/Travel1.jpeg';
import Header from '../components/Header';
import Footer from '../components/Footer';

function IntroCard({ src, children }) {
  return (
    <Card className="Cards">
      <div className="card-container">
        <div className="leftHalf">
          <img alt="avatar" src={src} className="imgStyle" />
        </div>
        <div className="rightHalf">
          <Typography.Title level={4}>{children}</Typography.Title>
          {/* <Button className="buttons" type="primary" target="_blank">
            Coming soon
          </Button> */}
        </div>
      </div>
    </Card>
  );
}

function Home() {
  return (
    <div className="App">
      <Header />
      <main className="content">
        <IntroCard src={xinhe}>
          <p>Discover premium lifestyle products and exquisite art pieces.</p>
        </IntroCard>
        <IntroCard src={pengyue}>
          <p>Transform your living spaces with Pengyue's elegant furnitures.</p>
        </IntroCard>
        <IntroCard src={Invest2}>
          <p>Discover prosperous emigration and business opportunities.</p>
        </IntroCard>
        <IntroCard src={Travel1}>
          <p>Experience the best of Japan with our personalized travel packages.</p>
        </IntroCard>
      </main>
      <Footer />
    </div>
  );
}

export default Home;